// extracted by mini-css-extract-plugin
module.exports = {"reviewContainer":"review_section_v2_reviewContainer__WvzSW"};